import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import * as actions from '../orderHistoryActions';
import { withStyles } from '@material-ui/core/styles';
import { Headline, Title1 } from '../../../components/Typography';
import { PrimaryButton } from '../../../components/Buttons';
import ProductsHistoryWrappers from './ProductsHistoryWrappers';
import CombosHistoryWrappers from './CombosHistoryWrappers';
import moment from 'moment';

const styles = () => ({
  paper: {
    margin: 0,
    maxWidth: '600px',
  },
});

const Wrapper = styled.div`
  padding: 12px;
  // width: 600px;

  @media (min-width: 786px) {
    padding: 32px;
    width: 600px;
  }
`;

const TitleWrapper = styled.div`
  margin-bottom: 20px;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
`;

const Title = styled(Title1)`
  color: ${(props) => props.theme.black};
  font-weight: 600;
`;

const DateAndAddAll = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  background: ${(props) => props.theme.orderAgainTitleBackgroundColor};
  color: ${(props) => props.theme.orderAgainTitleFontColor};
  border-radius: 8px;
  height: 51px;
  padding: 0 10px;
`;

const Cancel = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: white;
  background-color: ${(props) => props.theme.darkGray};
  right: 8px;
  top: 8px;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.closeButtonHoverColor};
    transition: all 0.25s ease;
  }
`;

const AddAllButton = styled(PrimaryButton)`
  border: 1px solid ${(props) => props.theme.orderAgainButtonBorderColor};
  height: 36px;
  font-size: 14px;
  box-shadow: none;
  border-radius: ${(props) => props.theme.addAllOrdersButtonRadius};
  background: ${(props) => props.theme.orderAgainTitleButtonBackgroundColor};
  color: ${(props) => props.theme.orderAgainTitleButtonFontColor};
  font-weight: 600;
  text-transform: ${(props) =>
    props.theme.addAllButtonTextTransform
      ? props.theme.addAllButtonTextTransform
      : 'uppercase'};

  &:hover {
    background: ${(props) =>
      props.theme.orderAgainTitleButtonBackgroundColorHover};
    border: 0;
    color: ${(props) =>
      props.theme.orderAgainTitleButtonTextColorHover} !important;
    transition: all 0.25s ease;
  }
`;
const OrderWrapper = styled.div`
  border: 1px solid ${(props) => props.theme.orderAgainBorderColor};
  border-radius: 12px;
`;

const Products = styled.div`
  margin: 10px 0;
`;

const ProductWrapper = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.isNoImage ? null : '70px auto')};
  grid-gap: 8px;
  padding: 10px 15px;
  align-items: center;
  cursor: ${(props) => (props.isAvailable ? 'pointer' : 'default')};

  &:hover {
    background-color: #faf9f9;
    transition: all 0.25s ease;
  }

  @media (max-width: 768px) {
    grid-template-columns: 56px auto;
    grid-gap: 5px;
  }
`;

const LocationWrapper = styled.span`
  font-size: 14px;
  font-weight: normal;
`;

const CardTitle = styled(Headline)`
  color: ${(props) => props.theme.orderAgainTitleFontColor};
`;

const OrderHistoryModal = ({
  orderHistoryModalIsVisible,
  setOrderHistoryModalIsVisible,
  classes,
  selectedOrderHistory,
  addPastOrderToCart,
  products,
  selectedLocation,
  combos,
}) => {
  const {
    pastOrderedProducts,
    pastOrderdCombos,
    orderLocationName,
  } = selectedOrderHistory;
  const [optionItems, setOptionItems] = useState([]);
  const formatModifiers = useCallback(() => {
    if (pastOrderedProducts?.length > 0) {
      const newModifires = pastOrderedProducts?.reduce((acc, curr) => {
        const options = curr?.options;
        let accOption = [];
        if (options?.length > 0)
          options.forEach((option) => {
            let currOption = {
              optionName: option.name,
              items: [],
            };
            if (option.items?.length > 0) {
              option.items.forEach((item) => {
                if ('sub_items' in item && item.sub_items.length > 0) {
                  item.sub_items.forEach((subItem) => {
                    currOption.items.push(subItem.name);
                  });
                } else {
                  currOption.items.push(item.name);
                }
              });
            }
            if (option?.sub_options?.length > 0) {
              option.sub_options.forEach((suboption) => {
                currOption.optionName = suboption.name;
                suboption.items.forEach((item) => {
                  if ('sub_items' in item && item.sub_items.length > 0) {
                    item.sub_items.forEach((subItem) => {
                      currOption.items.push(subItem.name);
                    });
                  } else {
                    currOption.items.push(item.name);
                  }
                });
              });
            }
            accOption.push(currOption);
          });
        acc.push({
          productName: curr.name,
          options: accOption,
        });
        return acc;
      }, []);
      setOptionItems(newModifires);
    }
  }, [selectedOrderHistory]);
  useEffect(() => {
    formatModifiers();
  }, [formatModifiers]);
  return (
    <Dialog
      open={orderHistoryModalIsVisible}
      onBackdropClick={() => setOrderHistoryModalIsVisible(false)}
      fullWidth={typeof window !== 'undefined' && window.innerWidth < 786}
      PaperProps={{ classes: { root: classes.paper } }}
      aria-labelledby='order-history-modal'
      scroll='body'
    >
      <Wrapper>
        <TitleWrapper>
          <Title id='OrderHistory-PastOrders'>Previous Order</Title>
          <Cancel
            id='OrderHistory-HistoryToggle'
            onClick={() => setOrderHistoryModalIsVisible(false)}
          >
            <i
              style={{ fontSize: '20px', fontWeight: '400' }}
              className='fal fa-times'
            />
          </Cancel>
        </TitleWrapper>
        <OrderWrapper style={{ margin: '10px' }}>
          <DateAndAddAll>
            <CardTitle>
              {moment(selectedOrderHistory.orderDate).format('MMM. DD')} -{' '}
              <LocationWrapper>{orderLocationName}</LocationWrapper>
            </CardTitle>
            {(pastOrderedProducts?.length > 1 ||
              pastOrderdCombos?.length > 1 ||
              (pastOrderdCombos?.length === 1 &&
                pastOrderedProducts?.length === 1)) && (
              <AddAllButton
                id='OrderHistory-AddAllButton'
                small
                onClick={() => {
                  addPastOrderToCart(
                    pastOrderedProducts,
                    pastOrderdCombos,
                    null
                  );
                  setOrderHistoryModalIsVisible(false);
                }}
              >
                Reorder
              </AddAllButton>
            )}
          </DateAndAddAll>
          <Products>
            {pastOrderdCombos?.map((comboItem, index) => {
              const foundCombo = combos.find(
                (combo) => comboItem.id === combo.id
              );
              return (
                <CombosHistoryWrappers
                  index={index}
                  combo={comboItem}
                  foundCombo={foundCombo}
                  optionItems={optionItems}
                  addPastOrderToCart={addPastOrderToCart}
                  setOrderHistoryModalIsVisible={setOrderHistoryModalIsVisible}
                />
              );
            })}
            {pastOrderedProducts?.map((product, index) => {
              const foundProduct = products.find(
                (menuProduct) => menuProduct.product_id === product.product_id
              );
              return (
                <ProductsHistoryWrappers
                  index={index}
                  product={product}
                  foundProduct={foundProduct}
                  optionItems={optionItems}
                  addPastOrderToCart={addPastOrderToCart}
                  setOrderHistoryModalIsVisible={setOrderHistoryModalIsVisible}
                />
              );
            })}
          </Products>
        </OrderWrapper>
      </Wrapper>
    </Dialog>
  );
  // }
  // return null;
};

const mapStateToProps = (state) => ({
  orderHistoryModalIsVisible:
    state.orderHistoryReducer.orderHistoryModalIsVisible,
  combos: state.comboReducer.combos,
});

export default withStyles(styles)(
  connect(mapStateToProps, actions)(OrderHistoryModal)
);
